<template>
  <div class="kye-preview-file-list-wrapper" :class="{ 'is-vertical': isVertical }">
    <slot name="prepend"></slot>
    <component
      :is="componentName"
      class="kye-preview-file-list-wrapper-item"
      v-for="item in fileList"
      :key="item.id"
      :url="item.url"
      :id="item.id"
      :size="itemSize"
      :fileName="item.name"
      :extendName="item.extendName"
      :canRemove="item.canRemove === false ? false : canRemove"
      :canDownload="canDownload"
      :canPreview="canPreview"
      @remove="remove"
      @download="download"
      @preview="preview"
    >
      <template slot="previewFileItem" slot-scope="{url, fileName, extendName}" v-if="$scopedSlots.previewFileItem">
        <slot name="previewFileItem" :url="url" :fileName="fileName" :extendName="extendName"></slot>
      </template>
    </component>
    <slot name="append"></slot>
  </div>
</template>
<script>
import FileItem from './file-item.vue'
import FileImage from './file-image.vue'
import { openPreview } from '../preview'
export default {
  name: 'KyePreviewList',
  components: { FileItem, FileImage },
  props: {
    viewType: {
      type: String,
      default: 'list' // list, image
    },
    direction: { // 渲染方向；水平或者垂直
      type: String,
      default: 'horizontal' // horizontal/vertical
    },
    itemSize: [Number, String, Array], // 宽*高
    list: {
      type: Array,
      default: () => ([])
    },
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    bizCode: String,
    bizId: String,
    imageProps: {
      type: Object,
      default: () => ({})
    },
    dialogOption: {
      type: Object,
      default: () => ({
        title: '图片查看',
        width: '900px',
      })
    },
    appendTo: [String, Object, HTMLElement],
    imgTypeList: Array,
    pdfTypeList: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'ofd']
    },
    mustPreivewType: {
      type: Array,
      default: () => []
    },
    isPrewFileToPdf: {
      type: Boolean,
      default: false
    },
    beforeDownload: Function,
    beforeRemove: Function,
    beforePreview: Function,
  },
  watch: {
    bizId: {
      immediate: true,
      handler(val) {
        val !== undefined && this.init()
      }
    },
    bizCode: {
      immediate: true,
      handler(val) {
        val !== undefined && this.init()
      }
    },
    list: {
      immediate: true,
      handler(val) {
        this.data = val || []
      }
    }
  },
  data () {
    return {
      data: []
    }
  },
  computed: {
    componentName () {
      return this.viewType === 'image' ? 'FileImage' : 'FileItem'
    },
    fileList: {
      get () {
        return [...this.data]
      },
      set (val) {
        this.$emit('update:list', [...val])
      }
    },
    isVertical () {
      return this.direction === 'vertical'
    }
  },
  methods: {
    // 删除
    remove(model) {
      this.$emit('remove', model)
    },
    // 下载
    async download(model) {
      const fn = this.beforeDownload
      if (fn && typeof fn === 'function') {
        const beforeDownload = fn(model)
        let flag = false
        if (beforeDownload && beforeDownload.then) {
          flag = await beforeDownload
        } else {
          flag = beforeDownload
        }
        if (flag === true) {
          return false
        }
      }
      window.erpOpen(model.url)
      this.$emit('download', model)
    },
    // 预览
    async preview (model) {
      const fn = this.beforePreview
      if (fn && typeof fn === 'function') {
        const beforePreview = fn(model)
        let flag = false
        if (beforePreview && beforePreview.then) {
          flag = await beforePreview
        } else {
          flag = beforePreview
        }
        if (flag === true) {
          return false
        }
      }
      openPreview({
        ...model,
        list: this.data,
        imageProps: this.imageProps,
        showDownload: this.showDownload,
        showDelete: this.showDelete,
        beforeRemove: this.beforeRemove,
        dialogOption: Object.assign({}, this.$props.dialogOption),
        ...this.$listeners,
        appendTo: this.appendTo,
        imgTypeList: this.imgTypeList,
        pdfTypeList: this.$props.pdfTypeList,
        isPrewFileToPdf: this.$props.isPrewFileToPdf,
        mustPreivewType: this.$props.mustPreivewType
      })
      this.$emit('preview', model)
    },
    async init () {
      const list = await this.getDataFromBizConf()
      if (list) {
        this.data = list
        this.$emit('getFileList', list)
      }
    },
    // 根据bizCode bizId查询文件列表
    async getDataFromBizConf () {
      try {
        const { bizCode, bizId } = this
        if (!bizCode || !bizId) {
          return []
        }
        const data = await this.$http('file.getByBizCodeAndBizId', {
          bizCode,
          bizId,
        })
        return data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.kye-preview-file-list-wrapper {
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  gap: 8px 0;
  &.is-vertical {
    flex-direction: column;
    align-items: start;
  }
  &.is-vertical &-item {
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-list.vue